<template>
  <div class="container">
    <div class="page_headers footerTabs disf">
      <div class="page_header_left">
        <div
          :class="`mwow-button-filled ${
            buttonAuth.followAdd ? 'success' : 'disable not-allowed'
          }`"
          @click="followdelDataDetails(id, 'add')"
        >
          添加记录
        </div>
        <el-popover
          placement="top"
          width="170"
          popper-class="followuppopover"
          trigger="hover"
        >
          <p class="tipck">
            添加跟进记录如果选择了【下次跟进时间】会自动创建跟进中计划;
          </p>
          <p class="tipck">
            对进行中计划跟进并填写内容，会生成【已完成】的跟进记录。
          </p>
          <div class="question" slot="reference">
            <div>?</div>
          </div>
        </el-popover>
        <div
          :class="`mwow-button-filled ${
            buttonAuth.experienceAdd ? 'primary' : 'disable not-allowed'
          }`"
          @click="toExperienceSechdule(detailsData)"
          style="margin-left: 24px"
        >
          添加体验
        </div>
        <div
          :class="`mwow-button-filled ${
            buttonAuth.export ? 'primary' : 'disable not-allowed'
          }`"
          @click="exportList(detailsData)"
          style="margin-left: 24px"
        >
          导出
        </div>
      </div>
    </div>
    <div v-if="fllowListConduct.length > 0">
      <div class="followupHead">跟进计划</div>
      <div
        class="followupCenter"
        v-for="(item, index) in fllowListConduct"
        :key="index"
      >
        <div class="followupCenterHead">
          <div class="followupCenter_left">
            <div class="followup_left_details">
              <span class="followupName">课程顾问：</span>
              <span>{{ item.staff.name }}</span>
            </div>
            <span class="light"></span>
            <div class="followup_left_details">
              <span class="followupName">跟进状态：</span>
              <span class="editBtn">未跟进</span>
            </div>
          </div>
          <div class="followupCenter_right">
            <span
              class="FoUpBtn"
              @click="followdelDataDetails(item, 'followUp')"
              >跟进</span
            >
            <span class="light"></span>
            <span class="editBtn" @click="followdelDataDetails(item, 'edit')"
              >编辑</span
            >
            <span class="light"></span>
            <span class="closeBtn" @click="followdelDataDetails(item, 'close')"
              >取消</span
            >
            <span class="light"></span>
            <span class="delBtn" @click="getfollowdelData(item)">删除</span>
          </div>
        </div>
        <div class="followupCenterHead">
          <div class="followupCenter_left">
            <div class="followup_left_details">
              <span class="followupName">沟通方式：</span>
              <span v-if="item.mode == 1">电话</span>
              <span v-if="item.mode == 2">微信</span>
              <span v-if="item.mode == 3">到访</span>
              <span v-if="item.mode == 4">介绍</span>
              <span v-if="item.mode == 5">其他</span>
            </div>
            <span class="light"></span>
            <div class="followup_left_details">
              <span class="followupName">计划时间：</span>
              <span>{{ item.pre_follow_time_data }}</span>
            </div>
            <span class="light"></span>
            <div class="followup_left_details">
              <span class="followupName">完成时间：</span>
              <span>{{ item.follow_time_data }}</span>
            </div>
            <span class="light"></span>
            <div class="followup_left_details">
              <span class="followupName">用户意向：</span>
              <span v-if="item.intent == 0">D</span>
              <span v-if="item.intent == 1" class="orderClose">C</span>
              <span v-if="item.intent == 2">B</span>
              <span v-if="item.intent == 3" class="editBtn">A</span>
            </div>
          </div>
        </div>
        <div class="followupCenterHead" v-if="item.content != ''">
          <div class="followupCenter_left">
            <div class="followup_left_details">
              <span v-if="item.stage === 6"
                >意向学员 “{{ studentName }}” 已转化为在读学员，转化订单号
                “<span
                  class="mwow-green"
                  style="cursor: pointer"
                  @click="toOrderDetail(item.relation_info.relation_id)"
                  >{{ item.relation_info.relation_value }}</span
                >”。</span
              >
              <span v-else>{{ item.content }}</span>
            </div>
          </div>
        </div>
        <div class="followupImg">
          <div
            class="imgbox"
            v-for="(items, index) in item.images_url"
            :key="index"
          >
            <span class="imgboxbig" @click="handlePictureCardPreview(items)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <img :src="items" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="fllowListOrder.length > 0">
      <div class="followupHead">跟进历史</div>
      <div v-for="(item, index) in fllowListOrder" :key="index">
        <div class="followupCenter" v-if="item.status != 4">
          <div class="followupCenterHead">
            <div class="followupCenter_left">
              <div class="followup_left_details">
                <span class="followupName">课程顾问：</span>
                <span>{{ item.staff.name }}</span>
              </div>
              <span class="light"></span>
              <div class="followup_left_details">
                <span class="followupName">跟进状态：</span>
                <span v-if="item.status == 2" class="editBtn">已跟进</span>
                <span v-if="item.status == 3" class="orderClose">已逾期</span>
              </div>
            </div>
            <div class="followupCenter_right">
              <span class="delBtn" @click="followdelDataDetails(item, 'look')"
                >查看</span
              >
              <span class="light"></span>
              <span class="delBtn" @click="getfollowdelData(item)">删除</span>
            </div>
          </div>

          <div class="followupCenterHead">
            <div class="followupCenter_left">
              <div class="followup_left_details">
                <span class="followupName">沟通方式：</span>
                <span v-if="item.mode == 0">-</span>
                <span v-if="item.mode == 1">电话</span>
                <span v-if="item.mode == 2">微信</span>
                <span v-if="item.mode == 3">到访</span>
                <span v-if="item.mode == 4">介绍</span>
                <span v-if="item.mode == 5">其他</span>
              </div>
              <span class="light"></span>
              <div class="followup_left_details">
                <span class="followupName">计划时间：</span>
                <span>{{ item.pre_follow_time_data }}</span>
              </div>
              <span class="light"></span>
              <div class="followup_left_details">
                <span class="followupName">完成时间：</span>
                <span>{{ item.follow_time_data }}</span>
              </div>
              <span class="light"></span>
              <div class="followup_left_details">
                <span class="followupName">用户意向：</span>
                <span v-if="item.intent == 0">D</span>
                <span v-if="item.intent == 1" class="orderClose">C</span>
                <span v-if="item.intent == 2">B</span>
                <span v-if="item.intent == 3" class="editBtn">A</span>
              </div>
            </div>
          </div>
          <div class="followupCenterHead" v-if="item.content != ''">
            <div class="followupCenter_left">
              <div class="followup_left_details">
                <span v-if="item.stage === 6"
                  >意向学员 “{{ studentName }}” 已转化为在读学员，转化订单号
                  “<span
                    class="mwow-green"
                    style="cursor: pointer"
                    @click="toOrderDetail(item.relation_info.relation_id)"
                    >{{ item.relation_info.relation_value }}</span
                  >”。</span
                >
                <span v-else>{{ item.content }}</span>
              </div>
            </div>
          </div>
          <div class="followupImg">
            <div
              class="imgbox"
              v-for="(items, index) in item.images_url"
              :key="index"
            >
              <span class="imgboxbig" @click="handlePictureCardPreview(items)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <img :src="items" alt="" />
            </div>
          </div>
        </div>
        <div class="followupCenter" v-else>
          <div class="followupCenterHead">
            <div class="followupCenter_left">
              <div class="followup_left_details">
                <span class="followupName">课程顾问：</span>
                <span>{{ item.staff.name }}</span>
              </div>
              <span class="light"></span>
              <div class="followup_left_details">
                <span class="followupName">{{ item.staff.mobile }}</span>
              </div>
              <span class="light"></span>
              <div class="followup_left_details">
                <span class="followupName">跟进状态：</span>
                <span>已取消</span>
              </div>
            </div>
            <div class="followupCenter_right">
              <span class="delBtn" @click="getfollowdelData(item)">删除</span>
            </div>
          </div>
          <div class="followupCenterHead" v-if="item.cancel_remark != ''">
            <div class="followupCenter_left">
              <div class="followup_left_details">
                <span class="followupName">取消原因：</span>
                <span>{{ item.cancel_remark }}</span>
              </div>
            </div>
          </div>
          <div class="followupImg">
            <div
              class="imgbox"
              v-for="(items, index) in item.images_url"
              :key="index"
            >
              <span class="imgboxbig" @click="handlePictureCardPreview(items)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <img :src="items" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-empty
      :image-size="32"
      v-if="fllowListConduct.length == 0 && fllowListOrder.length == 0"
      description="尚未添加跟进记录"
      image="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/nodata.png"
    ></el-empty>
    <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false">
      <img class="bigimg" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <detailsDialog
      v-if="showDialog"
      :type="dialogType"
      :itemdata="dialogidetailsid"
      @back="dialogHide"
    />
  </div>
</template>
<script>
import { PageModule } from "@/store/module/page";
import { dateFormat } from "@/utils/timeFormat";
import detailsDialog from "../detailsDialog.vue";
import { studentFollowExportApi } from "@/api/studentFollow";
import { studentDetail, getfollowdel, getfollowlist } from "@/api/studyDetails";
import { exportLoop } from "@/utils/export";
import { staffCheckApi } from "@/api/makeUpLessons";
import { waitingStudentClaimConfirm } from "@/utils/student-details";

export default {
  components: {
    detailsDialog,
  },
  // @Prop() studentInfo!: any;
  props: ["studentInfo", "visible"],
  data() {
    return {
      fllowListConduct: [], //跟进中记录
      fllowListOrder: [], //其他跟进记录
      showDialog: false, //弹框开关
      dialogType: "", //弹框类型
      dialogidetails: {}, //弹框数据
      dialogVisible: false,
      dialogImageUrl: "",
      detailsData: {},
      id: 0,
      buttonAuth: {
        followAdd: false,
        experienceAdd: false,
        export: false,
      },
    };
  },
  // get studentName() {
  //   return this.studentInfo.name;
  // }
  computed: {
    studentName() {
      return this.studentInfo.name;
    },
  },

  created() {
    this.id = Number(this.$route.query.id);
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.getfollowlistData({
          student_id: this.id,
        });
        this.getDetails(
          {
            student_id: this.id,
          },
          () => {}
        );
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.getfollowlistData({
        student_id: this.id,
      });
      this.getDetails(
        {
          student_id: this.id,
        },
        () => {}
      );
    }
    // 判断按钮权限
    staffCheckApi({
      api_path: [
        "/api/v1/student/follow/add",
        "/api/v1/class/lesson/experience/add",
        "/api/v1/student/follow/all_list/export",
      ],
    }).then((res) => {
      if (res.data["/api/v1/student/follow/add"]) {
        this.buttonAuth.followAdd = true;
      }
      if (res.data["/api/v1/class/lesson/experience/add"]) {
        this.buttonAuth.experienceAdd = true;
      }
      if (res.data["/api/v1/student/follow/all_list/export"]) {
        this.buttonAuth.export = true;
      }
    });
  },
  methods: {
    // 跟进记录
    getfollowlistData(id) {
      const _t = this;
      getfollowlist(id).then((res) => {
        if (res.error_code == 0) {
          _t.fllowListConduct = [];
          _t.fllowListOrder = [];
          if (res.data.list != null) {
            res.data.list.map((a) => {
              if (a.status == 1) {
                a.follow_time_data =
                  a.follow_time != 0
                    ? dateFormat(
                        "YYYY-mm-dd HH:MM",
                        new Date(Number(a.follow_time + "000"))
                      )
                    : "-";
                a.pre_follow_time_data =
                  a.pre_follow_time != 0
                    ? dateFormat(
                        "YYYY-mm-dd HH:MM",
                        new Date(Number(a.pre_follow_time + "000"))
                      )
                    : "-";
                _t.fllowListConduct.push(a);
              } else {
                a.follow_time_data =
                  a.follow_time != 0
                    ? dateFormat(
                        "YYYY-mm-dd HH:MM",
                        new Date(Number(a.follow_time + "000"))
                      )
                    : "-";
                a.pre_follow_time_data =
                  a.pre_follow_time != 0
                    ? dateFormat(
                        "YYYY-mm-dd HH:MM",
                        new Date(Number(a.pre_follow_time + "000"))
                      )
                    : "-";
                _t.fllowListOrder.push(a);
              }
            });
          }
        }
      });
    },
    // 时间格式化
    dateYearMonthDay(unixtime) {
      const dateTime = new Date(unixtime);
      const year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      if (month > 0 && month < 10) {
        month = "0" + month;
      }
      let day = dateTime.getDate();
      if (day > 0 && day < 10) {
        day = "0" + day;
      }
      const timeSpanStr = year + "-" + month + "-" + day;
      return timeSpanStr;
    },
    //跟进记录操作
    followdelDataDetails(item, type) {
      const _t = this;
      if (type == "add") {
        if (!_t.buttonAuth.followAdd) {
          return false;
        }
        if (
          !_t.detailsData.follow_staff_id &&
          _t.detailsData.status === 1 &&
          _t.detailsData.is_potential === 1 &&
          _t.$route.query.from === "waiting_student"
        ) {
          waitingStudentClaimConfirm({
            studentName: this.detailsData.name,
            studentID: Number(this.detailsData.student_id),
            claimSuccessCallback: () => {
              _t.showDialog = true;
              _t.dialogType = type;
              _t.dialogidetailsid = item;
            },
          });
        } else {
          if (_t.fllowListConduct.length > 0) {
            _t.$confirm(
              "目前已经有一条跟进中的计划，确定创建新的计划？",
              `重复 - 跟进记录`,
              {
                confirmButtonText: "确定",
                confirmButtonClass: "mwow-button-filled success mini",
                cancelButtonText: "取消",
                cancelButtonClass: "mwow-button-filled mini",
                type: "warning",
              }
            )
              .then(() => {
                _t.showDialog = true;
                _t.dialogType = type;
                _t.dialogidetailsid = item;
              })
              .catch(() => {});
          } else {
            _t.showDialog = true;
            _t.dialogType = type;
            _t.dialogidetailsid = item;
          }
        }
      } else {
        _t.showDialog = true;
        _t.dialogType = type;
        _t.dialogidetailsid = item;
      }
    },
    // 添加体验
    toExperienceSechdule(data) {
      const _t = this;
      if (!_t.buttonAuth.experienceAdd) {
        return false;
      }
      if (
        !_t.detailsData.follow_staff_id &&
        _t.detailsData.status === 1 &&
        _t.detailsData.is_potential === 1 &&
        _t.$route.query.from === "waiting_student"
      ) {
        waitingStudentClaimConfirm({
          studentName: this.detailsData.name,
          studentID: Number(this.detailsData.student_id),
          claimSuccessCallback: () => {
            PageModule.SET_PAGE_INFO({
              name: "recruitExperienceList",
              key: "selected_student",
              value: {
                avatar_url: data.avatar_url,
                is_del: data.is_del,
                mobile: data.mobile,
                name: data.name,
                org_id: data.org_id,
                sex: data.sex,
                status: data.status,
                student_id: data.student_id,
              },
            });
            _t.$router.push({
              name: "experienceSechdule",
              query: {
                sid: data.student_id,
                sname: data.name,
              },
            });
          },
        });
      } else {
        PageModule.SET_PAGE_INFO({
          name: "recruitExperienceList",
          key: "selected_student",
          value: {
            avatar_url: data.avatar_url,
            is_del: data.is_del,
            mobile: data.mobile,
            name: data.name,
            org_id: data.org_id,
            sex: data.sex,
            status: data.status,
            student_id: data.student_id,
          },
        });
        _t.$router.push({
          name: "experienceSechdule",
          query: {
            sid: data.student_id,
            sname: data.name,
          },
        });
      }
    },
    dialogHide(e) {
      const _t = this;
      _t.showDialog = false;
      if (e == "stop") {
        _t.getCourseList({
          student_id: _t.id,
        });
      } else if (e == "resume") {
        _t.getCourseList({
          student_id: _t.id,
        });
      } else if (e == "add" || e == "edit" || e == "followUp" || e == "close") {
        _t.getfollowlistData({
          student_id: _t.id,
        });
        // 添加跟进记录，重新获取里程碑
        this.$emit("refreshMilestone");
      } else if (e == "EaidsDetails") {
        _t.getDetails(
          {
            student_id: _t.id,
          },
          () => {
            _t.getCourseList({
              student_id: _t.id,
            });
          }
        );
      }
    },
    getDetails(id, cd) {
      const _t = this;
      if (!id) {
        id = { student_id: (_t.id = Number(_t.$route.query.id)) };
      }
      studentDetail(id).then((res) => {
        if (res.error_code == 0) {
          res.data.birthdaydate =
            res.data.birthday != 0
              ? _t.dateYearMonthDay(Number(res.data.birthday + "000"))
              : "-";
          _t.detailsData = res.data;
          if (cd) {
            cd();
          }
        }
      });
    },
    //删除跟进记录
    getfollowdelData(item) {
      const _t = this;
      _t.$confirm("确定删除后，跟进记录将无法恢复。", `删除 - 跟进记录`, {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      })
        .then(() => {
          getfollowdel({ follow_id: item.id }).then((res) => {
            if (res.error_code == 0) {
              // _t.getListData();
              this.getfollowlistData({
                student_id: this.id,
              });
              _t.$message({
                type: "success",
                message: "删除成功",
              });
            }
          });
        })
        .catch(() => {});
    },
    handlePictureCardPreview(e) {
      const _t = this;
      _t.dialogVisible = true;
      _t.dialogImageUrl = e;
    },
    exportList() {
      if (!this.buttonAuth.export) {
        return false;
      }
      studentFollowExportApi({
        page: 1,
        page_size: 10,
        student_id: this.id,
      }).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    toOrderDetail(id) {
      this.$router.push({
        name: "orderManageDetail",
        query: {
          id: String(id),
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  .question {
    width: 15px;
    height: 15px;
    opacity: 1;
    background: #bebfc0;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    line-height: 16px;
    font-size: 10px;
    margin-left: 5px;
  }
  .followup {
    .footerTabs {
      margin-top: 3px;
      margin-bottom: 20px;
    }
  }
  .followupHead {
    opacity: 1;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #5c5d5e;
    margin-top: 14px;
  }
  .followupCenter {
    padding: 0 19px;
    background: #f6fafc;
    margin-top: 14px;
    padding-bottom: 10px;
  }
  .followupCenterHead {
    display: flex;
    justify-content: space-between;
    height: 44px;
    align-items: center;
  }
  .followupImg {
    display: flex;
    flex-wrap: wrap;
    .imgbox {
      width: 80px;
      height: 80px;
      margin-right: 20px;
      cursor: pointer;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .imgboxbig {
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.7);
      i {
        position: relative;
        color: #fff;
        font-size: 20px;
      }
    }
    .imgbox:hover .imgboxbig {
      display: flex;
    }
  }
  .border {
    border-bottom: 1px solid #e7e8ea;
  }
  .followupCenterHead:last-child {
    margin-bottom: 0;
  }
  .followup_left_details {
    display: flex;
    align-items: center;
  }
  .followupCenter_left {
    display: flex;
    align-items: center;
    .followup_left_details {
      font-size: 12px;
      color: #5c5d5e;
      .followupName {
        font-weight: bold;
      }
    }
  }
  .followupCenter_right {
    display: flex;
    align-items: center;
    span {
      cursor: pointer;
    }
    .light {
      margin: 0 10px;
    }
  }
  .light {
    width: 1px;
    height: 16px;
    background-color: #dcdfe6;
    display: inline-block;
    margin: 0 20px;
  }
}
.page_header_left {
  display: flex;
  align-items: center;
}
.bigimg {
  max-width: 100%;
  max-height: 80vh;
  margin: 0 auto;
  display: block;
}
</style>
